module.exports = __webpack_public_path__ + "assets/img/soft12.be8e318a.jpg";